class AppointmentDatePicker {
  constructor() {
      this.dateSelect = document.getElementById('appointment-date');
      this.timeSelect = document.getElementById('time-slot');
      this.errorMessage = document.getElementById('errorMessage');
      this.timeErrorMessage = document.getElementById('timeErrorMessage');
      this.selectedDate = null;
      this.selectedTime = null;

      this.init();
  }

  init() {
      this.generateDateOptions();
      this.generateTimeOptions();
      this.attachEventListeners();
  }

  generateDateOptions() {
      const today = new Date();

      // Clear existing options except the first placeholder
      this.dateSelect.innerHTML = '<option value="">Select appointment date</option>';

      // Generate 15 days including today
      for (let i = 0; i < 15; i++) {
          const date = new Date(today);
          date.setDate(today.getDate() + i);

          const option = document.createElement('option');
          option.value = date.toISOString();
          option.textContent = this.formatDate(date);

          this.dateSelect.appendChild(option);
      }
  }

  generateTimeOptions() {

      this.timeSelect.innerHTML = '<option value="">Select time slot</option>';

      const timeSlots = [
      '11:00 AM - 12:00 PM', '12:00 PM - 01:00 PM', '01:00 PM - 02:00 PM',
      '02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM',
      '05:00 PM - 06:00 PM', '06:00 PM - 07:00 PM', '07:00 PM - 08:00 PM',
      '08:00 PM - 09:00 PM', '09:00 PM - 10:00 PM',
      ];

      timeSlots.forEach(time => {
          const option = document.createElement('option');
          option.value = time;
          option.textContent = time;
          this.timeSelect.appendChild(option);
      });
  }

  formatDate(date) {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const dayName = days[date.getDay()];
      const day = String(date.getDate()).padStart(2, '0');
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      return `(${dayName}) ${day} ${month} ${year}`;
  }

  convertTimeToDate(timeString, baseDate) {
      const [time, period] = timeString.split(' ');
      const [hours, minutes] = time.split(':').map(Number);

      let hour24 = hours;
      if (period === 'PM' && hours !== 12) {
          hour24 += 12;
      } else if (period === 'AM' && hours === 12) {
          hour24 = 0;
      }

      const dateTime = new Date(baseDate);
      dateTime.setHours(hour24, minutes || 0, 0, 0);
      return dateTime;
  }

  updateTimeSlotAvailability() {
      if (!this.selectedDate) {
          // Reset all time slots to enabled
          Array.from(this.timeSelect.options).forEach((option, index) => {
              if (index > 0) { // Skip the placeholder option
                  option.disabled = false;
                  option.style.color = '';
              }
          });
          return;
      }

      const now = new Date();
      const isToday = this.selectedDate.toDateString() === now.toDateString();

      Array.from(this.timeSelect.options).forEach((option, index) => {
          if (index === 0) return; // Skip placeholder

          if (isToday) {
              const slotDateTime = this.convertTimeToDate(option.value, this.selectedDate);
              const isPast = slotDateTime <= now;

              option.disabled = isPast;
              if (isPast) {
                  option.style.color = '#999';
                  option.textContent = option.value + ' (Past)';
                  option.remove();
              } else {
                  option.style.color = '';
                  option.textContent = option.value;
              }
          } else {
              option.disabled = false;
              option.style.color = '';
              option.textContent = option.value;
          }
      });

      // If current time selection is now invalid, clear it
      if (this.timeSelect.value && this.timeSelect.selectedOptions[0].disabled) {
          this.timeSelect.value = '';
          this.selectedTime = null;
      }
  }

  showError(element, errorElement, message) {
      element.classList.add('error');
      errorElement.textContent = message;
      errorElement.style.display = 'block';
  }

  clearError(element, errorElement) {
      element.classList.remove('error');
      errorElement.style.display = 'none';
  }

  validateDate() {
      if (!this.dateSelect.value) {
          this.showError(this.dateSelect, this.errorMessage, 'Please select an appointment date');
          return false;
      }
      this.clearError(this.dateSelect, this.errorMessage);
      return true;
  }

  validateTime() {
      if (!this.timeSelect.value) {
          this.showError(this.timeSelect, this.timeErrorMessage, 'Please select a time slot');
          return false;
      }

      // Check if selected time is in the past
      if (this.selectedDate && this.selectedTime) {
          const selectedDateTime = this.convertTimeToDate(this.selectedTime, this.selectedDate);
          const now = new Date();

          if (selectedDateTime <= now) {
              this.showError(this.timeSelect, this.timeErrorMessage, 'Selected time slot is in the past');
              return false;
          }
      }

      this.clearError(this.timeSelect, this.timeErrorMessage);
      return true;
  }

  validateBoth() {
      const dateValid = this.validateDate();
      const timeValid = this.validateTime();
      return dateValid && timeValid;
  }

  attachEventListeners() {
      // Handle date selection
      this.dateSelect.addEventListener('change', (e) => {
          if (e.target.value) {
              this.selectedDate = new Date(e.target.value);
              this.clearError(this.dateSelect, this.errorMessage);
              this.updateTimeSlotAvailability();
          } else {
              this.selectedDate = null;
              this.updateTimeSlotAvailability();
          }
      });

      // Handle time selection
      this.timeSelect.addEventListener('change', (e) => {
          if (e.target.value) {
              this.selectedTime = e.target.value;
              this.clearError(this.timeSelect, this.timeErrorMessage);
          } else {
              this.selectedTime = null;
          }
      });

      // Form validation on blur
      this.dateSelect.addEventListener('blur', () => {
          this.validateDate();
      });

      this.timeSelect.addEventListener('blur', () => {
          this.validateTime();
      });
  }

  // Public method to get selected date
  getSelectedDate() {
      return this.selectedDate;
  }

  // Public method to get selected time
  getSelectedTime() {
      return this.selectedTime;
  }

  // Public method to get formatted date string
  getFormattedDate() {
      return this.selectedDate ? this.formatDate(this.selectedDate) : null;
  }

  // Public method to get combined date-time
  getSelectedDateTime() {
      if (this.selectedDate && this.selectedTime) {
          return this.convertTimeToDate(this.selectedTime, this.selectedDate);
      }
      return null;
  }

  // Public method to get selected values
  getSelectedValues() {
      return {
          date: this.dateSelect.value,
          time: this.timeSelect.value,
          dateFormatted: this.getFormattedDate(),
          dateTime: this.getSelectedDateTime()
      };
  }

  // Public validation method
  validate() {
      return this.validateBoth();
  }
}

// Initialize the date picker when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const datePicker = new AppointmentDatePicker();

  // Example of how to access the selected values
  window.getAppointmentDate = () => {
      return datePicker.getSelectedDate();
  };

  window.getAppointmentTime = () => {
      return datePicker.getSelectedTime();
  };

  window.getFormattedAppointmentDate = () => {
      return datePicker.getFormattedDate();
  };

  window.getAppointmentDateTime = () => {
      return datePicker.getSelectedDateTime();
  };

  window.getAppointmentValues = () => {
      return datePicker.getSelectedValues();
  };

  window.validateAppointment = () => {
      return datePicker.validate();
  };
});